import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const ASE_INTERNAL_TICKET_HISTORY_FETCH_PENDING = 'ASE_INTERNAL_TICKET_HISTORY_FETCH_PENDING';

export const fetchAseInternalTicketHistoryPageData = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: ASE_INTERNAL_TICKET_HISTORY_FETCH_PENDING,
        aseWebsocket: true,
        command: aseWebsocketCommands.ASE_INTERNAL_TICKET_HISTORY_GET,
        payload: {pageSize: pageSize, sorted: sorted, cursor, isNextFromPivot, filtered: filtered}
    });
};
